<div>
 <div class="" >

   <span class="join gap-8 text-sm">
    <span class="">Global stats :</span>
    <!-- planned jobs -->
    <span class="join-item flex items-center gap-2 text-orange-600">
      <svg width="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ><path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5"/><path d="M16 2v4"/><path d="M8 2v4"/><path d="M3 10h5"/><path d="M17.5 17.5 16 16.3V14"/><circle cx="16" cy="16" r="6"/></svg>
      <span class="">{{globalPlannedJobs}}</span>
    </span>

    <!-- failed jobs -->
    <span class="join-item flex items-center gap-2 text-cliking_red">
      <svg width="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-warning-icon lucide-file-warning"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>
      <span class="">{{globalFailedJobs}}</span>
    </span>
    I
    <!-- published -->
    <span class="join-item flex items-center gap-2 text-cliking_green">
      <svg  width="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>
      <span class="">{{globalPublished}}</span>
    </span>

    <!-- planned  -->
    <span class="join-item flex items-center gap-2 text-cliking_yellow">
      <svg width="18"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
      <span class="">{{globalPlanned}}</span>
    </span>

    <!-- draft -->
    <span class="join-item flex items-center gap-2 text-clinking_gray">
      <svg  width="18"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.1 2.182a10 10 0 0 1 3.8 0"/><path d="M13.9 21.818a10 10 0 0 1-3.8 0"/><path d="M17.609 3.721a10 10 0 0 1 2.69 2.7"/><path d="M2.182 13.9a10 10 0 0 1 0-3.8"/><path d="M20.279 17.609a10 10 0 0 1-2.7 2.69"/><path d="M21.818 10.1a10 10 0 0 1 0 3.8"/><path d="M3.721 6.391a10 10 0 0 1 2.7-2.69"/><path d="M6.391 20.279a10 10 0 0 1-2.69-2.7"/></svg>
      <span class="">{{globalDrafts}}</span>
    </span>
    
    <!-- failed  -->
    <span class="join-item flex items-center gap-2 text-cliking_red">
      <svg width="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-triangle-alert-icon lucide-triangle-alert"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>
      <span class="">{{globalFailed}}</span>
    </span>
    I
    <!-- group with pages -->
    <span class="join-item flex items-center gap-2 text-cliking_blue">
      <svg  width="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ><path d="m9 10 2 2 4-4"/><rect width="20" height="14" x="2" y="3" rx="2"/><path d="M12 17v4"/><path d="M8 21h8"/></svg>
      <span class="">{{groupsWithSocialMedias}}</span>
    </span>

     <!-- group without pages -->
    <span class="join-item flex items-center gap-2 text-orange-400">
        <svg width="18"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-monitor-x-icon lucide-monitor-x"><path d="m14.5 12.5-5-5"/><path d="m9.5 12.5 5-5"/><rect width="20" height="14" x="2" y="3" rx="2"/><path d="M12 17v4"/><path d="M8 21h8"/></svg>
      <span class="">{{groupsWthoutSocialMedias}}</span>
    </span>
    I
    <!-- facebook pages -->
    <span class="join-item flex items-center gap-2">
      <app-social-media-round-icon [source]="'facebook'" />
      <span class="">{{facebookPages}}</span>
    </span>

    <!-- instagram pages -->
    <span class="join-item flex items-center gap-2">
      <app-social-media-round-icon [source]="'instagram'" />
      <span class="">{{instaPages}}</span>
    </span>

    <!-- google pages -->
    <span class="join-item flex items-center gap-2">
      <app-social-media-round-icon [source]="'google'" />
      <span class="">{{googlePages}}</span>
    </span>

    <!-- linkedin pages -->
    <span class="join-item flex items-center gap-2">
      <app-social-media-round-icon [source]="'linkedin'" />
      <span class="">{{linkedinPages}}</span>
    </span>
    I
    <!-- published Posts -->
    <span class="join-item flex items-center gap-2 text-green-700">
      <svg  width="20"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="m9 15 2 2 4-4"/></svg>
      <span class="">{{postsPublished}}</span>
    </span>

    <!-- never published Posts -->
    <span class="join-item flex items-center gap-2 text-red-700">
     <svg width="20"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="m14.5 12.5-5 5"/><path d="m9.5 12.5 5 5"/></svg>
      <span class="">{{postsNeverPublished}}</span>
    </span>
    
  </span>
  <!-- filters form -->
  <form action="">
    <label for="tit"></label><input type="text">
    <label for=""></label><input type="text">
    <label for=""></label><input type="text">
    <label for=""></label><input type="text">
  </form>

  <!-- results -->
  </div>
</div>
